import { carsStore } from '.';
import { action, observable } from 'mobx';

class MapStore {
  @observable areaSearching = false;

  @observable openedMarker = undefined;

  @observable usingApiKey = true;

  constructor(carsStore) {
    this.carsStore = carsStore;
  }

  @action setAreaSearching = areaSearching => {
    this.areaSearching = areaSearching;
  };

  @action setOpenedMarker = (openedMarker) => {
    this.openedMarker = openedMarker;
  };

  @action clearOpenedMarker = () => {
    this.openedMarker = undefined;
  };
}
export default new MapStore(carsStore);



// WEBPACK FOOTER //
// ./src/stores/mapStore.js